import { RACE_COLORS, FONT_FAMILY } from "../constants.js";

const CARD_DEFS = [
  { key: "frisk",  label: "STOPS WITH A FRISK",       verb: "frisk" },
  { key: "search", label: "STOPS WITH A SEARCH",       verb: "search" },
  { key: "force",  label: "USE OF FORCE",               verb: "use force against" },
  { key: "camera", label: "BODY / DASH CAMERA ON",      verb: "have camera on for" },
];

function ratioText(card, verb) {
  const { black_pct, white_pct } = card;
  if (black_pct == null || white_pct == null) return "Disparity ratio cannot be calculated";
  if (black_pct === 0 && white_pct === 0) return "Disparity ratio cannot be calculated";
  if (black_pct === 0 || white_pct === 0) return "Disparity ratio cannot be calculated";
  const r = black_pct / white_pct;
  if (Math.round(r * 100) === 100) return `Equal rates for Black and White residents`;
  if (r > 1) return `${r.toFixed(2)}x more likely to ${verb} Black residents`;
  return `${(white_pct / black_pct).toFixed(2)}x more likely to ${verb} White residents`;
}

function ratioColor(card) {
  const { black_pct, white_pct } = card;
  if (black_pct == null || white_pct == null) return "#999";
  if (black_pct === 0 || white_pct === 0) return "#999";
  if (black_pct === 0 && white_pct === 0) return "#999";
  const r = black_pct / white_pct;
  if (Math.round(r * 100) === 100) return "#999";
  if (r > 1) return RACE_COLORS.BLACK;
  return RACE_COLORS.WHITE;
}

const cardStyle = {
  background: "#f8f9fa",
  border: "1px solid #e0e0e0",
  borderRadius: 10,
  padding: "18px 20px",
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 0,
};

const labelStyle = {
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: "0.06em",
  color: "#555",
  textTransform: "uppercase",
  fontFamily: FONT_FAMILY,
};

const pctRowStyle = {
  display: "flex",
  gap: 24,
  alignItems: "baseline",
};

const bigNumStyle = (color) => ({
  fontSize: "clamp(22px, 5vw, 32px)",
  fontWeight: 800,
  color,
  fontFamily: FONT_FAMILY,
  lineHeight: 1,
});

const raceTagStyle = (color) => ({
  fontSize: 12,
  fontWeight: 600,
  color,
  fontFamily: FONT_FAMILY,
});

const ratioTextStyle = (color) => ({
  fontSize: 13,
  color,
  fontFamily: FONT_FAMILY,
  marginTop: 4,
  fontStyle: "italic",
  fontWeight: 600,
});

export default function DisparityCards({ data }) {
  if (!data) return null;

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: 16,
      marginTop: 8,
    }}>
      {CARD_DEFS.map(({ key, label, verb }) => {
        const card = data[key];
        if (!card) return null;
        return (
          <div key={key} style={cardStyle}>
            <div style={labelStyle}>{label}</div>
            <div style={pctRowStyle}>
              <div>
                <div style={raceTagStyle(RACE_COLORS.BLACK)}>BLACK</div>
                <div style={bigNumStyle(RACE_COLORS.BLACK)}>
                  {card.black_pct != null ? `${card.black_pct}%` : "—"}
                </div>
              </div>
              <div>
                <div style={raceTagStyle(RACE_COLORS.WHITE)}>WHITE</div>
                <div style={bigNumStyle(RACE_COLORS.WHITE)}>
                  {card.white_pct != null ? `${card.white_pct}%` : "—"}
                </div>
              </div>
            </div>
            <div style={ratioTextStyle(ratioColor(card))}>{ratioText(card, verb)}</div>
          </div>
        );
      })}
    </div>
  );
}
